import { render, staticRenderFns } from "./phoneMenu.vue?vue&type=template&id=b3d64394&scoped=true"
import script from "./phoneMenu.vue?vue&type=script&lang=js"
export * from "./phoneMenu.vue?vue&type=script&lang=js"
import style0 from "./phoneMenu.vue?vue&type=style&index=0&id=b3d64394&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d64394",
  null
  
)

export default component.exports